import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Loader from "../components/Loader";
const BASE_URL = process.env.REACT_APP_BASE_URL;
const apiKey = process.env.REACT_APP_API_KEY;

export default function DeleteCountry(){
    const {id} = useParams();
    const [countries, setCountry] = useState([]);
    const navigate = useNavigate();
    const API_URL = BASE_URL+"/getcountries";

    useEffect(() => {
        axios.get(API_URL, {
            headers: {
                "Authorization": apiKey,
                "Content-Type": "application/json"
            }
        })
        .then(
            res => {
                setCountry(res.data)
                setLoading(false);
            }
        )
        .catch(
            error => {
                console.log("There was an error", error);
            }
        )
    }, [])

    const deleteCountry = () => {
        const DELETE_URL = BASE_URL+`/deletecountry/${id}`;
        axios.delete(DELETE_URL, {
            headers: {
                "Authorization": apiKey,
                "Content-Type": "application/json"
            }
        })
        .then(
            res => {
                navigate("/countries");
                // console.log(res);
            }
        )
        .catch(
            error => {
                console.log("There was an error", error);
            }
        )
    }
    const [loading, setLoading] = useState(true);
    if (loading) return <Loader />;
    return(
        <div className="container">
            <br /><br />
            {countries.filter(country => country.Id == id)
            .map(country => (
                <h2>Are you sure you want to delete <i>"{country.Country}"</i> ?</h2>
            ))}
            <br />
            <button className="btn btn-danger" onClick={deleteCountry}>Yes Delete</button>
        </div>
    )
}